import React, { useState } from "react";
import { useAuth } from "./hooks/UserAuth.js";

export function LoginForm() {
    const auth = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    function validateForm() {
        return email.length > 0 && password.length > 0;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        try {
            const result = await auth.signin(email, password);
            if (!result) throw new Error("Неправильний логін або пароль");
        } catch (err) {
            setError("Неправильний логін або пароль. Спробуйте ще раз.");
        } finally {
            setIsLoading(false);
        }
    }

    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '80vh',
            fontFamily: 'system-ui, -apple-system, sans-serif'
        },
        card: {
            width: '100%',
            maxWidth: '400px',
            padding: '2.5rem',
            borderRadius: '16px',
            boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
            backgroundColor: '#fff',
            border: '1px solid #f0f0f0'
        },
        errorBox: {
            backgroundColor: '#fff5f5',
            color: '#e53e3e',
            padding: '0.75rem',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            fontSize: '0.9rem',
            textAlign: 'center',
            border: '1px solid #feb2b2'
        },
        input: {
            width: '100%',
            padding: '0.75rem',
            borderRadius: '8px',
            border: error ? '1px solid #fc8181' : '1px solid #ddd',
            boxSizing: 'border-box',
            marginBottom: '1.2rem',
            fontSize: '1rem',
            transition: 'all 0.2s'
        },
        button: {
            width: '100%',
            padding: '0.8rem',
            backgroundColor: (validateForm() && !isLoading) ? '#2563eb' : '#94a3b8',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: (validateForm() && !isLoading) ? 'pointer' : 'not-allowed',
            transition: 'background-color 0.2s'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={{textAlign: 'center', marginBottom: '1.5rem', color: '#1e293b'}}>Вхід в систему</h2>
                <h4 style={{textAlign: 'center', marginBottom: '1.5rem', color: '#2c384b'}}>Lasciate ogne speranza, voi ch'entrate
                </h4>

                {/* Error block */}
                {error && <div style={styles.errorBox}>{error}</div>}

                <form onSubmit={handleSubmit}>
                    <label style={{
                        display: 'block',
                        marginBottom: '0.5rem',
                        fontSize: '0.85rem',
                        color: '#64748b'
                    }}>Email</label>
                    <input
                        type="email"
                        placeholder="your@email.com"
                        style={styles.input}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <label style={{
                        display: 'block',
                        marginBottom: '0.5rem',
                        fontSize: '0.85rem',
                        color: '#64748b'
                    }}>Пароль</label>
                    <input
                        type="password"
                        placeholder="••••••••"
                        style={styles.input}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                        type="submit"
                        disabled={!validateForm() || isLoading}
                        style={styles.button}
                    >
                        {isLoading ? "Зачекайте..." : "Увійти"}
                    </button>
                </form>
            </div>
        </div>
    );
}